import {classNames, React, useAsync} from '@api'
import {ContextMenuItem, HeaderSyncIndicator, useStores} from '@modules'
import {observer} from '@api'
import * as css from './CurrentWorkspaceSyncToolbarButton.css'

/// region Components

interface MyProps {
  className?: string
  location: 'header' | 'toolbar' | 'menu'
}

export const CurrentWorkspaceSyncToolbarButton = observer<MyProps & React.HTMLProps<any>>(function CurrentWorkspaceSyncToolbarButton({className, location, ...props}) {
  const {
    vlp,
    ui: {settings: {showHeaderSyncIndicator}}, syncProgress,
    flexLayout: {isMaximized, flexEnabled}, catalog: {index}, workspaces: {workspaceConfig, getWorkspaceLastSync}} = useStores(),
    {value: lastSyncInfo} = useAsync<string>(async () => {
      return workspaceConfig ? await getWorkspaceLastSync() : null
    }, [workspaceConfig?._id, syncProgress.byId.get(index)?.itemId])

  if (!vlp || showHeaderSyncIndicator === false || (location == 'header' && flexEnabled && !isMaximized)) return null

  return (
    <HeaderSyncIndicator {...props} className={classNames(css.root, className)} lastSyncTimeMap={new Map([[index, lastSyncInfo]])} itemId={index} location={location} trigger={'workspace'} isSyncIndex/>
  )
})

/// endregion



// WEBPACK FOOTER //
// ./src/modules/syncIndicator/CurrentWorkspaceSyncToolbarButton.tsx